.iframe {
  background: #fff;
  pointer-events: none;
  display: block;
  border: none;
}
